import Container, {
  PAPER_PADDING,
  DESKTOP_PAPER_PADDING_Y,
  DESKTOP_PAPER_PADDING_X,
} from './Container'
import Title from './Title'
import Subtitle from './Subtitle'
import Spacer from './Spacer'

// TODO: get rid of this component. The main use is the background for 'Section',
// having it embedded in other components makes them unuseable in any of our Sections
// or we will have to some gnarly stuff style wise to make them fit.

const Paper = {
  Container,
  Spacer,
  Title,
  Subtitle,
  PAPER_PADDING,
  DESKTOP_PAPER_PADDING_Y,
  DESKTOP_PAPER_PADDING_X,
}

export default Paper
